import { Dayjs } from "dayjs";
import { TFunction } from "i18next";
import * as Yup from "yup";

const DEFAULT_ZOOM = 10;

export const createMapSchema = (t: TFunction) =>
    Yup.object({
        label: Yup.string().required(t("addElement.validator.required")),
        type: Yup.string().required(t("addElement.validator.required")),
        url: Yup.string().required(t("addElement.validator.required")),
        minX: Yup.number().required(t("addElement.validator.required")),
        minY: Yup.number().required(t("addElement.validator.required")),
        maxX: Yup.number().required(t("addElement.validator.required")),
        maxY: Yup.number().required(t("addElement.validator.required")),
        min_zoom: Yup.number()
            .default(DEFAULT_ZOOM)
            .required(t("addElement.validator.required")),
        max_zoom: Yup.number()
            .default(DEFAULT_ZOOM)
            .required(t("addElement.validator.required")),
        start_date: Yup.mixed<Dayjs>().required(
            t("addElement.validator.required"),
        ),
        end_date: Yup.mixed<Dayjs>().nullable().optional(),
    });
